export default class AddressNamesHelper {
    static stringifyAddressNames(addressNames, defaultTown = undefined) {
        let result = '';
        if (addressNames) {
            for (const addressName of addressNames) {
                if (addressName.road) {
                    if (result) {
                        result += ', ' + addressName.road;
                    }
                    else {
                        result += addressName.road;
                    }
                    if (addressName.town) {
                        if (addressName.town !== defaultTown) {
                            result += ' (' + addressName.town + ')';
                        }
                    }
                }
            }
        }
        return result;
    }
}
;
